import React from "react";
import { motion } from "framer-motion";
import { FaCheckCircle, FaArrowLeft, FaEnvelope } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./ThankYou.css";
import Footer from '../../components/Footer/Footer';
import FloatingWebsiteNavigation from "../../components/FloatingWebsiteNavigation/FloatingWebsiteNavigation";

const ThankYou = () => {
  const navigate = useNavigate();

  const containerVariants = {
    offscreen: {
      y: 50,
      opacity: 0
    },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 0.8
      }
    }
  };

  const iconVariants = {
    offscreen: {
      scale: 0,
      opacity: 0
    },
    onscreen: {
      scale: 1,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.6,
        duration: 0.8,
        delay: 0.2
      }
    }
  };

  const handleReturnToContact = () => {
    navigate("/contact");
  };

  return (
    <>
      <div className="thank-you-wrapper">
        <motion.div
          className="thank-you-container"
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: true, amount: 0.3 }}
          variants={containerVariants}
        >
          <motion.div 
            className="thank-you-icon"
            variants={iconVariants}
          >
            <FaCheckCircle />
          </motion.div>

          <motion.div className="thank-you-content" variants={containerVariants}>
            <h1>Thank You!</h1>
            <p className="thank-you-message">
              Your message has been successfully sent. We'll get back to you as soon as possible.
            </p>
            
            <div className="thank-you-details">
              <div className="detail-item">
                <FaEnvelope className="detail-icon" />
                <span>We'll respond within 24 hours</span>
              </div>
              <div className="detail-item">
                <FaCheckCircle className="detail-icon" />
                <span>Your message is being processed</span>
              </div>
            </div>

            <motion.button
              className="return-button"
              onClick={handleReturnToContact}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaArrowLeft className="button-icon" />
              <span>Return to Contact</span>
            </motion.button>
          </motion.div>
        </motion.div>
      </div>
      <Footer />
      <FloatingWebsiteNavigation />
    </>
  );
};

export default ThankYou;
